import { render, staticRenderFns } from "./LabelSongList.vue?vue&type=template&id=60de1a6e&"
import script from "./LabelSongList.vue?vue&type=script&lang=ts&"
export * from "./LabelSongList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports